<template>
  <div style="width:100%;padding-top: 60px">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">
          办理
        </van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea"
                       placeholder="请输入审批说明"/>
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>

    <van-collapse v-model="activeNames">
            <van-collapse-item title="基本信息" name="1">
              <van-field v-model="inputForm.projectName" label="物业项目名称" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
              <van-field v-model="inputForm.customerName" label="客户名称" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
              <van-field v-model="inputForm.remarks" label="退款说明" label-width="100px" readonly input-align="left" :border="false" autosize rows="1" type="textarea"/>
<!--              <div style="padding-left: 16px;" v-show="inputForm.attachList.length > 0">-->
<!--                <p>附件</p>-->
<!--                <a style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" :href="file.url">{{file.name}}</a>-->
<!--              </div>-->
              <div style="padding-left: 16px;" v-show="inputForm.attachList.length > 0">
                <p>附件</p>
                <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
              </div>
            </van-collapse-item>
      <van-collapse-item title="退款明细" name="2">
        <div class="m-form">
<!--          <div class="title">退款明细</div>-->
          <div v-for="(data, index) in inputForm.details" :key="index">
            <div class="m-row">
              <div class="m-row-text">房号</div>
              <div class="m-row-content">{{ data.wuyeFinanceReceivable.houseName }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">收费项目名称</div>
              <div class="m-row-content">{{ data.wuyeFinanceReceivable.feeItemName }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">计费区间</div>
              <div class="m-row-content">
                {{
                  timestampToTime(data.wuyeFinanceReceivable.startDate) + '至' + timestampToTime(data.wuyeFinanceReceivable.endDate)
                }}
              </div>
            </div>
            <div class="m-row">
              <div class="m-row-text">收款金额(元)</div>
              <div class="m-row-content">{{ Number(data.wuyeFinanceReceivable.paymentAmount).toFixed(2) }}</div>
            </div>
            <div class="m-row">
              <div class="m-row-text">申请退款(元)</div>
              <div class="m-row-content">{{ Number(data.amount).toFixed(2) }}</div>
            </div>
          </div>
          <!--        <div class="m-row">-->
          <!--          <div class="m-row-text">收款总额</div>-->
          <!--          <div class="m-row-content">{{ amounts.toFixed(2) }}元</div>-->
          <!--        </div>-->
          <!--        <div class="m-row">-->
          <!--          <div class="m-row-text">退款总额</div>-->
          <!--          <div class="m-row-content">{{ refundAmounts.toFixed(2) }}元</div>-->
          <!--        </div>-->
          <!--        <div class="m-row" style="border-bottom: 1px solid #eee">-->
          <!--          <div class="m-row-text">是否减免</div>-->
          <!--          <div class="m-row-content">{{inputForm.isDerated === '1' ? '是' : '否' }}</div>-->
          <!--        </div>-->
        </div>
      </van-collapse-item>
<!--      <div class="m-form">-->
<!--        <div class="title">基本信息</div>-->
<!--        <div class="m-row">-->
<!--          <div class="m-row-text">物业项目名称</div>-->
<!--          <div class="m-row-content">{{ inputForm.projectName }}</div>-->
<!--        </div>-->
<!--        <div class="m-row">-->
<!--          <div class="m-row-text">客户名称</div>-->
<!--          <div class="m-row-content">{{ inputForm.customerName }}</div>-->
<!--        </div>-->
<!--        <div class="m-row" style="border-bottom: 1px solid #eee">-->
<!--          <div class="m-row-text">退款说明</div>-->
<!--          <div class="m-row-content large-content">{{ inputForm.remarks }}</div>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="m-form" v-if="inputForm.attachList.length > 0">-->
<!--        <div class="title">附件信息</div>-->
<!--        <div class="m-row" v-for="(file, index) in inputForm.attachList" :key="index"-->
<!--             style="height: 30px; line-height: 30px; border-bottom: 1px solid #eee; border-right: 1px solid #eee">-->
<!--          <a style="display: block;" :href="file.url">{{ file.name }}</a>-->
<!--        </div>-->
<!--      </div>-->

      <!--      <van-collapse-item title="退款明细" name="2">-->
      <!--		<div class="m-row" v-for="data in inputForm.details" style="color:black;">-->
      <!--			<div>房号：{{data.wuyeFinanceReceivable.houseName}}</div>-->
      <!--			<div>费项：{{data.wuyeFinanceReceivable.feeItemName}}</div>-->
      <!--			<div>计费区间：{{timestampToTime(data.wuyeFinanceReceivable.startDate)+'至'+timestampToTime(data.wuyeFinanceReceivable.endDate)}}</div>-->
      <!--			<div class="m-row-row">-->
      <!--				<div>收款（元）：{{data.wuyeFinanceReceivable.paymentAmount}}</div>-->
      <!--				<div class="m-row-row-padding">申请退款（元）：{{data.amount}}</div>-->
      <!--			</div>-->
      <!--		</div>-->
      <!--		-->
      <!--		<div style="width: 100%;text-align: right;padding-right: 20px;margin-top: 10px;color: black;">-->
      <!--			收款总额：{{amounts.toFixed(2)}} 元， 退款总额：{{refundAmounts.toFixed(2)}} 元-->
      <!--		</div>-->
      <!--		<van-cell center title="是否减免">-->
      <!--		  <template #right-icon>-->
      <!--		    <van-switch v-model="inputForm.isDerated" size="24" disabled/>-->
      <!--		  </template>-->
      <!--		</van-cell>-->
      <!--      </van-collapse-item>-->
      <!--      <van-collapse-item title="退款说明" name="3">-->
      <!--        <van-field v-model="inputForm.remarks" rows="2" autosize type="textarea" readonly/>-->
      <!--      </van-collapse-item>-->
      <!--      <van-collapse-item title="附件信息" name="4" v-show="inputForm.attachList.length > 0">-->
      <!--        <a style="display: block;" v-for="file in inputForm.attachList" :href="file.url">{{ file.name }}</a>-->
      <!--      </van-collapse-item>-->
    </van-collapse>

    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import RefundService from '@/api/finance/RefundService.js'
import ProcessService from '../../api/flowable/ProcessService'
import TaskService from '@/api/flowable/TaskService.js'
import processRecord from "../../components/processRecord/processRecord";

export default {
  data() {
    return {
      activeNames: ['1', '2', '3', '4'],
      isshow: false,
      radio: '',
      inputForm: {
        id: '',
        projectId: '',
        projectName: '',
        customerId: '',
        customerName: '',
        houseId: '',
        houseName: '',
        feeItemNames: '',
        exchangeId: '',
        code: '',
        status: '',
        remarks: '',
        createDate: '',
        createByName: {
          id: ''
        },
        details: [
          {
            wuyeFinanceReceivable: {
              houseName: '',
              feeItemName: '',
              startDate: '',
              endDate: '',
              amount: '',

            }
          }
        ],
        isDoTask: false,
        isLastTask: false,
        attachIds: [],
        attachList: [],
        reason: ''
      },
      amounts: 0,
      refundAmounts: 0,
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      businessId: '',
      type: ''
    }
  },
  mounted() {
  },
  components: {
    processRecord
  },
  created() {
    let query = this.$route.query;
    this.businessId = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    // let id = this.$cookie.get('id')
    // this.taskId = this.$cookie.get('taskId')
    // this.taskDefKey = this.$cookie.get('taskDefKey')
    // this.procInsId = this.$cookie.get('procInsId')
    // this.procDefId = this.$cookie.get('procDefId')
    this.init(this.businessId)

  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    init(id) {
      new RefundService().queryById(id).then(({data}) => {
        this.inputForm = data

        this.amounts = 0
        this.refundAmounts = 0
        this.inputForm.details.forEach(d => {
          this.amounts += d.wuyeFinanceReceivable.paymentAmount
          this.refundAmounts += d.amount
        })
      }).catch(e => {
        console.log(e)
      })
    },
    timestampToTime(timestamp) {
      let date = new Date(timestamp);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d;// + " " + h + ":" + m + ":" + s;
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        vars = {...vars, ..._this.inputForm}
        // _this.auditForm.message = _this.auditForm.message
		
		_this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'

        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          businessTable: 'wuye_finance_refund_apply',
          businessId: this.businessId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = _this.inputForm.isLastTask ? 4 : 2;
          new RefundService().startFlow(_this.inputForm);

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = 3;
          new RefundService().startFlow(_this.inputForm);

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
.m-form {
  width: 100vw;
  padding: 10px;
  font-size: 12px;
}

.title {
  width: calc(100vw - 20px);
  height: 30px;
  background-color: #eeeeee;
  line-height: 30px;
  font-weight: bold;
  padding-left: 5px;
  box-sizing: border-box;
}

.m-row {
  display: flex;
  width: calc(100vw - 22px);
  border: 1px solid #eee;
  border-bottom: 0px;
}

.m-row-text {
  width: 110px;
  padding-left: 5px;
  border-right: 1px solid #eee;
  /*border-bottom: 1px solid #eee;*/
  display: flex;
  align-items: center;
  /*background-color: #eee;*/
}

.m-row-content {
  width: calc(100vw - 130px);
  height: 30px;
  line-height: 30px;
  padding-left: 10px;
}

.large-content {
  width: calc(100vw - 130px);
  min-height: 30px;
  height: auto;
  padding-left: 10px;
  overflow: hidden;
}
</style>